<script>
  import ListHeader from '../../../components/list/Header.vue'
  import ListMain from '../../../components/list/Main.vue'
  import RegistrationStatusLabel from './show/labels/RegistrationStatusLabel'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import DataService from '../../../services/dataService'
  import dateMixin from '../../../../mixins/helper'
  import bus from '@utils/bus'
  import {mapGetters} from 'vuex'
  import {isEmpty, clone} from 'lodash'

  export default {
    components: {ListHeader, ListMain, RegistrationStatusLabel},
    mixins: [dateMixin],
    data () {
      return {
        isLoadingData: true,
        event: {
          id: null,
          title: ''
        },
        filters: {ref_pessoa: '', dates: [], status_id: ''},
        form: {
          ref_pessoa: ''
        },
        registrationActivity: {
          datetime_in: '',
          datetime_out: '',
          event_id: '',
          user_id: '',
          registration_id: ''
        },
        dependencies: {}
      }
    },
    mounted () {
      this.getDependencies()
      const id = this.$route.params.id || null
      if (id) {
        restfulService.get('event', null, id)
          .then(response => {
            this.event.id = id
            this.event.title = response.title
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch((err) => {
            console.log(err)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
        bus.$emit('list-init', {
          domain: 'registration',
          route: 'activities',
          customSearch: true,
          relations: [
            'registration.person',
            'registration.status',
            'event_modality_registration.event_modality.event'
          ],
          data: {event_main_id: id}
        }, () => {
          this.isLoadingData = false
        })
      } else {
        this.isLoadingData = false
      }
      this.$nextTick(() => {
        this.$refs.formMatricula.$el.children['formMatricula'].focus()
      })
    },
    computed: {
      ...mapGetters(['listStore', 'currentUser']),
      pageTitle: function () {
        return this.event.title + ' - Presença'
      },
      labelType: function () {
        return 'danger'
      }
    },
    methods: {
      getDependencies () {
        DataService.get([{domain: 'status'}]).then((result) => {
          this.dependencies = result
        })
      },
      onFilter () {
        const id = this.$route.params.id || null
        let searchData = {event_main_id: id}
        if (this.filters.status_id) {
          searchData.status_id = this.filters.status_id
        }
        if (!isEmpty(this.filters.ref_pessoa)) {
          searchData.ref_pessoa = this.filters.ref_pessoa
        }
        let startDate = this.dateFormat(this.filters.dates[0], 'en')
        let endDate = this.dateFormat(this.filters.dates[1], 'en')
        if (startDate.length > 0 && endDate.length > 0) {
          searchData.start_date = startDate + ' 00:00:00'
          searchData.end_date = endDate + ' 23:59:59'
        } else if (startDate.length > 0 && endDate.length === 0) {
          searchData.start_date = startDate + ' 00:00:00'
          searchData.end_date = startDate + ' 23:59:59'
        } else if (startDate.length === 0 && endDate.length > 0) {
          searchData.start_date = endDate + ' 00:00:00'
          searchData.end_date = endDate + ' 23:59:59'
        }
        bus.$emit('list-filter', this.filters, searchData)
      },
      onInsert () {
        this.isSubmitted = true
        let data = {
          event_main_id: this.event.id,
          ref_pessoa: this.form.ref_pessoa
        }
        if (!isEmpty(data.ref_pessoa)) {
          restfulService.post('registration_activity', null, null, data)
            .then(() => {
              this.isSubmitted = false
              notifyService.success({
                hideLoader: true,
                message: 'O registro de presença foi inserido com sucesso.'
              })
              this.onInsertClean()
            })
            .catch((err) => {
              console.log(err)
            })
        } else {
          this.$swal({
            title: 'Atenção',
            text: 'Favor informar uma matrícula!',
            type: 'warning'
          })
        }
      },
      onFilterClean () {
        const id = this.$route.params.id || null
        let searchData = {event_main_id: id}
        this.filters = {ref_pessoa: '', status_id: '', dates: []}
        bus.$emit('list-filter-clean', this.filters, searchData)
      },
      onInsertClean () {
        this.form.ref_pessoa = ''
        this.onFilterClean()
      },
      onDestroy (item) {
        bus.$emit('list-destroy-item', item)
      },
      cancelRegistrationActivity (registrationActivity) {
        this.isSubmitted = true
        this.$swal({
          title: 'Deseja realmente cancelar o registro de presença no evento?',
          text: 'Essa ação não pode ser revertida!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, continuar!'
        })
          .then(() => {
            bus.$emit('show-loader')
            let data = clone(registrationActivity)
            data.canceled_by = this.currentUser.id
            restfulService.put('registration_activity', null, registrationActivity.id, data)
              .then(response => {
                this.isSubmitted = false
                notifyService.success({hideLoader: true, message: 'O registro de presença foi cancelada com sucesso.'})
                this.onFilter()
                bus.$emit('hide-loader')
              })
              .catch(e => {
                this.isSubmitted = false
                bus.$emit('hide-loader')
                console.log(e)
              })
          })
          .catch(e => {
            console.log(e)
            bus.$emit('hide-loader')
          })
      }
    },
    beforeMount () {
      this.listStore.listData = []
    }
  }
</script>

<template>
    <div>
        <ListHeader :title="pageTitle" back-route="event.index"/>
        <el-card class="el-card__search_list box-card">
            <div slot="header">
                <span>Inserir presença</span>
                <div>
                    <el-button type="primary" @click="onInsert">Salvar</el-button>
                    <el-button type="default" @click="onInsertClean">Limpar</el-button>
                </div>
            </div>
            <el-form class="demo-form-inline"
                     :model="form"
                     @submit.native.prevent>
                <el-form-item label="Matrícula">
                    <el-input v-model="form.ref_pessoa"
                              name="formMatricula"
                              ref="formMatricula"
                              @keyup.enter.native="onInsert"
                              placeholder="Digite a matrícula ou leia com o leitor de códigos de barra"/>
                </el-form-item>
            </el-form>
        </el-card>
        <ListMain>
            <div slot="filters" style="margin-top: 15px">
                <el-card class="el-card__search_list box-card">
                    <div slot="header">
                        <span>Filtrar Listagem</span>
                        <div>
                            <el-button type="primary" @click="onFilter">Pesquisar</el-button>
                            <el-button type="default" @click="onFilterClean">Limpar</el-button>
                        </div>
                    </div>
                    <el-form :inline="true" :model="filters" class="demo-form-inline">
                        <el-form-item label="Matrícula">
                            <el-input v-model="filters.ref_pessoa" placeholder="Filtrar por matrícula"/>
                        </el-form-item>
                        <el-form-item label="Data de Entrada">
                            <el-date-picker
                                    v-model="filters.dates"
                                    type="daterange"
                                    format="dd/MM/yyyy"
                                    placeholder="Filtrar por data">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="Status Financeiro">
                            <el-select v-model="filters.status_id"
                                       filterable
                                       placeholder="Filtrar Status"
                                       empty-text="Nenhum registro encontrado">
                                <el-option v-for="item in dependencies.status"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div>

            <div slot="list" v-if="!isLoadingData && event.id">
                <table class="custom-table-list">
                    <thead>
                    <tr>
                        <th>Cód. Inscrição</th>
                        <th>Participante</th>
                        <th>Nome</th>
                        <th>Evento</th>
                        <th>Entrada</th>
                        <th>Saída</th>
                        <th>Financeiro</th>
                        <th width="100">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listStore.listData">
                        <td>{{item.id}}</td>
                        <td>{{item.registration.person.ref_pessoa}}</td>
                        <td>{{item.registration.person.pessoa.nome}}</td>
                        <td>{{item.event_modality_registration.event_modality.event.title}}</td>
                        <td>{{item.datetime_in | dateTimeEnToBr }}</td>
                        <td>{{item.datetime_out | dateTimeEnToBr }}</td>
                        <td>
                            <div>
                                <registration-status-label :status-id="item.registration.status_id"
                                                           :status-name="item.registration.status.name"/>
                            </div>
                        </td>
                        <td>
                            <el-button v-if="!item.canceled_by" type="danger"
                                       @click="cancelRegistrationActivity(item)"
                                       :disabled="item.canceled_by"
                                       title="Cancelar Inscrição">
                                <i class="fa fa-times"></i>
                            </el-button>
                            <div v-if="item.canceled_by">
                                <el-tag :type="labelType">Cancelado</el-tag>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    </tfoot>
                </table>
            </div>
        </ListMain>
    </div>
</template>

<style>
    .el-tag {
        padding: 4px 10px;
        height: 24px;
        line-height: 15px;
    }
</style>



// WEBPACK FOOTER //
// Presence.vue?33a37b50